<div class="table-container">
  <mat-progress-bar *ngIf="loading" mode="query" type="indeterminate"></mat-progress-bar>
  <mat-table *ngIf="perdidas && perdidas?.length > 0" #table [dataSource]="perdidas"
    class="mat-elevation-z2" matSort>

    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef class="row-header-x10">
        <h5>Fecha</h5>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="row-header-x10">
        {{element.fecha | date}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="materia">
      <mat-header-cell *matHeaderCellDef class="row-header-x30">
        <h5>Materia</h5>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="row-header-x30">
        {{getMateria(element.materiaCursoPeriodoID, materias)}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="horas">
      <mat-header-cell matTooltip="" *matHeaderCellDef class="row-header-x5">
        <h5>Horas</h5>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="row-header-x5">
        {{element.horas | number}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="motivo">
      <mat-header-cell matTooltip="" *matHeaderCellDef class="row-header-x50">
        <h5>Motivo</h5>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="row-header-x50">
        {{element.motivo}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="accion">
      <mat-header-cell *matHeaderCellDef class="row-header-x5">
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="row-header-x5">
        <button mat-icon-button color="warn" matTooltip="Borrar registro" matTooltipPosition="before"
          (click)="deleteClasePerdida(element)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *matRowDef="let element; columns: displayedColumns">
    </mat-row>

    <mat-row *matNoDataRow>
      <mat-cell class="mat-cell" colspan="5">No se encontraron registros</mat-cell>
    </mat-row>

  </mat-table>
  <div *ngIf="!perdidas || perdidas?.length === 0" class="no-records" style="text-align: center;">
    Sin registros
  </div>
  
  <div *ngIf="errorMessage" class="alert alert-danger" class="no-records" style="text-align: center;">
    Error: {{ errorMessage }}
  </div>
</div>